import React, { Component } from 'react';
import classnames from 'classnames';
import isNil from 'lodash/isNil';

import {
  setTextLinksToOpenInNewPage,
  setTextLinksToDisplayExternalOpenMsg,
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

import { IntersectionDetector } from 'zoomforth_zfutils/viewport_intersection_utils.js';
import { ConditionalWrapper } from 'zoomforth_page_version_viewer/utils.js';

import { bindTextLinkClickTrackingEvents } from 'zoomforth_codesbane_viewer/lib/analytics/utils.js';

import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';
class TextSection_Base extends Component {
  constructor(props) {
    super(props);
    this.wrapperNodeRef = null;
    this.state = {
      visibility: false,
    };
  }

  componentDidMount() {
    this.doPostRender();
  }

  componentDidUpdate() {
    this.doPostRender();
  }

  render() {
    const {
      uuid,
      fontSize,
      htmlString,
      stylePresetClassName,
      animationClasses,
      animationRunsOnce,
    } = this.props;

    return (
      <ConditionalWrapper
        condition={!isNil(animationClasses)}
        wrapper={(children) => (
          <IntersectionDetector
            animationClasses={animationClasses}
            triggerOnce={animationRunsOnce}
          >
            {children}
          </IntersectionDetector>
        )}
      >
        <div
          ref={(ref) => {
            this.wrapperNodeRef = ref;
          }}
          className={classnames('text-wrapper', stylePresetClassName, {
            [`content-uuid-${uuid}`]: uuid,
          })}
        >
          <div
            style={{ fontSize: `${fontSize ? fontSize : '100'}%` }}
            dangerouslySetInnerHTML={{ __html: htmlString }}
          />
        </div>
      </ConditionalWrapper>
    );
  }
}

class TextSection_ViewerVersion1 extends TextSection_Base {
  constructor(props) {
    super(props);

    this.wrapperNodeRef = null;
  }

  doPostRender() {
    bindTextLinkClickTrackingEvents(
      this.wrapperNodeRef,
      '.text-section-inner a',
      'textsectionlink'
    );
    setTextLinksToOpenInNewPage(this.wrapperNodeRef, '.text-section-inner a');
  }
}

class TextSection_ViewerVersion2 extends TextSection_Base {
  constructor(props) {
    super(props);

    this.wrapperNodeRef = null;
  }

  doPostRender() {
    bindTextLinkClickTrackingEvents(
      this.wrapperNodeRef,
      '.text-section-inner a',
      'textsectionlink'
    );
    setTextLinksToOpenInNewPage(this.wrapperNodeRef, '.text-section-inner a');
    setTextLinksToDisplayExternalOpenMsg(
      this.wrapperNodeRef,
      '.text-section-inner a'
    );
  }
}

const TextSection = (props) => (
  <SiteViewerVersionComponentSelector>
    <TextSection_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <TextSection_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

export default TextSection;
